import { render, staticRenderFns } from "./MemberTalkMemberList.vue?vue&type=template&id=0879c718&scoped=true&"
import script from "./MemberTalkMemberList.vue?vue&type=script&lang=js&"
export * from "./MemberTalkMemberList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0879c718",
  null
  
)

export default component.exports